/* GGC Racing redesign 2026-10: mega-menu + mobile drawer behaviour */
(function () {
  'use strict';
  var OPEN_DELAY = 110, SWITCH_DELAY = 30, CLOSE_DELAY = 220;
  var nav = document.querySelector('[data-gg-nav]');
  if (!nav) return;
  var items = [].slice.call(nav.querySelectorAll('[data-gg-item]'));
  var openItem = null, timer = null;
  var coarse = window.matchMedia && window.matchMedia('(hover: none)').matches;

  function link(item) { return item.querySelector('.gg-nav__link'); }
  function hasPanel(item) { return !!item.querySelector('[data-gg-panel]'); }
  function open(item) {
    if (openItem === item) return;
    close();
    if (!hasPanel(item)) return;
    item.classList.add('is-open');
    link(item).setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('gg-mega-open');
    openItem = item;
    var w = item.querySelector('[data-ggc-ymm]'); if (w) w.dispatchEvent(new Event('mouseenter'));
  }
  function close() {
    if (!openItem) return;
    openItem.classList.remove('is-open');
    link(openItem).setAttribute('aria-expanded', 'false');
    openItem = null;
    document.documentElement.classList.remove('gg-mega-open');
  }
  function later(fn, ms) { clearTimeout(timer); timer = setTimeout(fn, ms); }

  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () { if (!coarse) later(function () { open(item); }, openItem ? SWITCH_DELAY : OPEN_DELAY); });
    item.addEventListener('mouseleave', function () { if (!coarse) later(close, CLOSE_DELAY); });
    var a = link(item);
    a.addEventListener('click', function (e) {
      if (!hasPanel(item)) return;
      // touch devices: first tap opens the panel, second follows the link
      if (coarse && openItem !== item && !a.hasAttribute('data-gg-ride')) { e.preventDefault(); open(item); }
    });
    a.addEventListener('keydown', function (e) {
      var i = items.indexOf(item), nxt = null;
      if (e.key === 'ArrowRight') nxt = items[(i + 1) % items.length];
      else if (e.key === 'ArrowLeft') nxt = items[(i - 1 + items.length) % items.length];
      if (nxt) { e.preventDefault(); var wasOpen = openItem === item; close(); link(nxt).focus(); if (wasOpen) open(nxt); return; }
      if (!hasPanel(item)) return;
      if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); open(item); var f = item.querySelector('.gg-ride select:not([disabled]), .gg-col__link'); if (f) f.focus(); }
    });
    var panel = item.querySelector('[data-gg-panel]');
    if (panel) panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(); link(item).focus(); }
    });
    item.addEventListener('focusin', function (e) { if (!coarse && e.target === link(item)) open(item); });
  });
  nav.addEventListener('mouseenter', function () { clearTimeout(timer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); closeDrawer(); } });
  document.addEventListener('click', function (e) { if (openItem && !nav.contains(e.target)) close(); });
  nav.addEventListener('focusout', function (e) { if (openItem && !nav.contains(e.relatedTarget)) close(); });

  /* ---- Shop Your Ride / Garage triggers (reuse existing YMM modal + garage tab) ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gg-ride]');
    if (t) {
      var modal = document.querySelector('.size-shop-modal');
      if (modal) {
        e.preventDefault(); e.stopPropagation(); close(); closeDrawer(); modal.classList.add('show');
        var hash = ((t.getAttribute('href') || '').split('#')[1] || '');
        if (hash === 'tires' || hash === 'wheels') {
          var tabBtn = modal.querySelector('.ggc-tabs__tab[data-tab="' + hash + '"]'); if (tabBtn) tabBtn.click();
        }
      }
      return;
    }
    var g = e.target.closest('[data-gg-garage]');
    if (g) {
      var tab = document.querySelector('.ggc-ymm-garage-tab');
      e.preventDefault(); close(); closeDrawer();
      if (tab) tab.click();
    }
  }, true);


  /* ---- Vehicle-type toggle (swaps the popular-platform chips) ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gg-vt]'); if (!t) return;
    var scope = t.closest('.gg-panel__inner, .gg-acc__panel') || document; var type = t.getAttribute('data-gg-vt');
    [].slice.call(t.parentNode.children).forEach(function (b) { b.classList.toggle('is-on', b === t); });
    [].slice.call(scope.querySelectorAll('[data-gg-type]')).forEach(function (u) { u.hidden = u.getAttribute('data-gg-type') !== type; });
  });

  /* ---- Mobile drawer ---- */
  var drawer = document.querySelector('[data-gg-drawer]');
  var overlay = document.querySelector('[data-gg-overlay]');
  var burger = document.querySelector('[data-gg-open-drawer]');
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    document.documentElement.classList.add('gg-lock');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    var c = drawer.querySelector('[data-gg-close-drawer]'); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    setTimeout(function () { overlay.hidden = true; }, 250);
    document.documentElement.classList.remove('gg-lock');
    if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus(); }
  }
  if (burger) burger.addEventListener('click', openDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  var cb = document.querySelector('[data-gg-close-drawer]'); if (cb) cb.addEventListener('click', closeDrawer);
  window.addEventListener('resize', function () { if (window.innerWidth >= 1200) closeDrawer(); });

  [].slice.call(document.querySelectorAll('.gg-acc__btn[aria-controls]')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      // one section open at a time keeps the drawer short
      [].slice.call(document.querySelectorAll('.gg-acc__btn[aria-expanded="true"]')).forEach(function (o) {
        o.setAttribute('aria-expanded', 'false'); var p = document.getElementById(o.getAttribute('aria-controls')); if (p) p.hidden = true;
      });
      if (!isOpen) { btn.setAttribute('aria-expanded', 'true'); panel.hidden = false; var w = panel.querySelector('[data-ggc-ymm]'); if (w) w.dispatchEvent(new Event('mouseenter')); btn.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
    });
  });
})();
